import * as React from 'react';

import classnames from 'classnames';

import {isSafeUrlPath} from 'nutshell-core/utils/is-safe-url-path';

import {TextfieldWithSaveAndCancel} from '../textfield/textfield-with-save-and-cancel';

import styles from './pathname-field.module.css';

type Props = {
    domainName: string | null | undefined;
    value: string;
    onChange: (arg1: string) => void;
    placeholder?: string;
    onSave: () => void;
    onCancel: () => void;
    hasError?: boolean;
    isEditing: boolean;
    onSelectEdit: () => void;
    isDisabled?: boolean;
    showUpgradeButton?: boolean;
    onClickUpgradeButton?: () => void;
};

export function PathnameFieldWithButtons(props: Props) {
    const domainNameTextStyle = classnames(styles['domain-name-text-with-buttons'], {
        [styles['domain-name-text-with-buttons--disabled']]: props.isDisabled,
    });

    const pathnameFieldStyle = classnames(styles['pathname-field-with-buttons'], {
        [styles['pathname-field-with-buttons--grid']]: Boolean(props.domainName),
    });

    return (
        <div className={pathnameFieldStyle}>
            {props.domainName && (
                <div title={props.domainName} className={domainNameTextStyle}>
                    <span className={styles['domain-name-text-ltr']}>{`${props.domainName}/`}</span>
                </div>
            )}
            <div className='flex full-width align-center'>
                <TextfieldWithSaveAndCancel
                    value={props.value}
                    onSave={props.onSave}
                    onCancel={props.onCancel}
                    placeholder={props.placeholder}
                    onTextfieldChange={(newPath) => {
                        // No spaces, other URL safety validated on backend
                        if (props.isEditing) {
                            const safePath = newPath.replace(' ', '');
                            if (isSafeUrlPath(safePath)) {
                                props.onChange(safePath);
                            }
                        }
                    }}
                    hasError={props.hasError}
                    noBorder={true}
                    isEditing={props.isEditing}
                    onSelectEdit={props.onSelectEdit}
                    isDisabled={props.isDisabled}
                    showUpgradeButton={props.showUpgradeButton}
                    onClickUpgradeButton={props.onClickUpgradeButton}
                    hideEditButton={props.isDisabled}
                />
            </div>
        </div>
    );
}
